<div class="statistics-single-value">
    <div class="matrix-header">
        @if (!isVacationHome()) {
        <div class="text">Kjøperne kommer fra...</div>
        } @if (isVacationHome()) {
        <div class="text">Eierne bor nå i...</div>
        }
        <ev-arrow-choice
            [textDirection]="'right'"
            [options]="['%', 'Antall']"
            (change)="buyerNumberChanged($event)"
        ></ev-arrow-choice>
        <div
            class="info-icon"
            (clickOutside)="changeMatrixTooltip.show = false"
            (click)="changeMatrixTooltip.show = !changeMatrixTooltip.show"
            [class.hidden] = "isVacationHome()"
        >
            <ev_tooltip [visible]="changeMatrixTooltip.show" [left]="-270" [bottom]="27" [arrow]="'bottom'" [arrowBottomAlign]="-8" [arrowAlignRight]="31">
                <div class="popup-info">
                    <div class="header">{{ changeMatrixTooltip.header }}</div>
                    @for (txt of changeMatrixTooltip.info; track txt) {
                    <div class="body">{{ txt }}</div>
                    }
                </div>
            </ev_tooltip>
        </div>
    </div>
</div>

@for (county of CountyView; track county; let i = $index) {
<div class="graph">
    <div class="graphData" [class.bg-black]="county.toggle" >
        @if (county.Num > 0) {
        <div class="graphTitle">
            {{ county.Name }}
        </div>
        } @if (county.Num > 0) {
        <div class="graphProgressbar">
            <div
                class="graphInnerProgressbar"
                [class.roundedBorder]="(county.Num / countyTotal) * 100 >= 95"
                [style.width.%]="(county.Num / countyTotal) * 100"
            ></div>
            <div class="progressValue">{{ showBuyers ? county.Num : ((county.Num / countyTotal) * 100 | rounded) + "%" }}</div>
        </div>
        }
        <div id="EVTEST-BUYER_ORIGIN-COUNTYTOGGLE" class="expand-header" [class.expanded]="county.toggle" (click)="toggleExpanded(i)"></div>
    </div>
    @for (council of countyData[i][0]; track council; let j = $index) {
    <div class="expand bg-black" [class.expanded]="county.toggle" >
        <div class="councilData">
            <div class="graphTitle">{{ council.Name }}</div>
            <div class="graphProgressbar">
                <div class="progressValue">{{ showBuyers ? council.Num : ((council.Num / countyTotal) * 100 | rounded) + "%" }}</div>
            </div>
            <div
                id="EVTEST-BUYER_ORIGIN-COUNCILTOGGLE"
                class="expand-header"
                [class.expanded]="council.toggle"
                (click)="toggleExpandedCouncil(i, j)"
            ></div>
        </div>
        @if (districtData[i][j]?.length > 1 && council.toggle) {
        <div class="info-box">
            <div class="info-header">Bydel</div>
            @for (district of districtData[i][j]; track district) {
            <div class="councilExpand bg-black" [class.councilExpanded]="council.toggle">
                <div class="districtData">
                    <div class="graphTitle">
                        {{ district.Name }}
                        @if (district.Name === 'Andre') {
                        <div class="price-number">
                            <h5>{{ districtTotal[i][j] }}</h5>
                        </div>
                        }
                    </div>
                    <div class="graphProgressbar">
                        <div class="progressValue">{{ showBuyers ? district.Num : ((district.Num / countyTotal) * 100 | rounded) + "%" }}</div>
                    </div>
                </div>
            </div>
            }
        </div>
        } @if (council.toggle) {
        <div class="info-box" [class.councilExpanded]="council.toggle">
            <div class="info-header">Grunnkrets</div>
            @for (area of areaData[i][j]; track area) {
            <div class="councilExpand bg-black" [class.councilExpanded]="council.toggle">
                <div class="districtData">
                    <div class="graphTitle">
                        {{ area.Name }}
                        @if (area.Name === 'Andre') {
                        <div class="price-number">
                            <h5>{{ areaTotal[i][j] }}</h5>
                        </div>
                        }
                    </div>
                    <div class="graphProgressbar">
                        <div class="progressValue">{{ showBuyers ? area.Num : ((area.Num / countyTotal) * 100 | rounded) + "%" }}</div>
                    </div>
                </div>
            </div>
            }
        </div>
        }
    </div>
    }
</div>
}
<div>
    <div class="range-container">
        @if (graphTotalNum() > 0) {
        <div class="row">
            <div class="text grey">{{ graphTotalNum() < 100000 ? "Grunnlag" : "Gr.lag" }}</div>
            &nbsp;
            <div class="value">{{ graphTotalNum() }}</div>
        </div>
        } @if (graphTotalNum() == 0) {
        <div class="row">
            <div class="text grey">{{ "Grunnlag savnes" }}</div>
        </div>
        }
    </div>
</div>
